function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useRef } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { useRouter } from 'next/router';
/**
 * A function for checking if the URL is ending with a file extension.
 **/
var isFileURL = function isFileURL(url) {
  var _url;
  url = new URL(url);
  return ((((_url = url) === null || _url === void 0 ? void 0 : _url.pathname.split('/')) || []).pop() || []).indexOf('.') > 0;
};

/**
 * This component wraps the Sitecore JSS RichText component, that makes it possible to use the RichText in the Experience Editor.
 *
 * Originally copied from:
 * https://kamsar.net/index.php/2018/09/Routing-Sitecore-links-with-JSS/#Rich-Text-Fields
 *
 * However, the component is converted from a class component to be a functional component.
 *
 * PLEASE NOTE! Parent props are needed for routeHandler, see routerOrHistory constant below.
 **/
export var RoutableSitecoreRichText = function RoutableSitecoreRichText(props) {
  var richTextRef = useRef(null);
  var history = props.history,
    field = props.field,
    editable = props.editable;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var routerOrHistory = history ? history : useRouter();
  var goToRoute = function goToRoute(pathname) {
    if (routerOrHistory) {
      void routerOrHistory.push(pathname);
    } else {
      window.location.pathname = pathname;
    }
  };
  var routeHandler = function routeHandler(event) {
    event.preventDefault();
    var eventTarget = event === null || event === void 0 ? void 0 : event.target;
    if ('tagName' in eventTarget && eventTarget.tagName !== 'A') {
      var eventParentNode = eventTarget.parentNode;
      if (eventParentNode.tagName === 'A') {
        goToRoute(eventParentNode.pathname);
      }
    } else {
      goToRoute(eventTarget.pathname);
    }
  };

  // rebinds event handlers to route links within this component
  // fired both on mount and update
  var bindRouteLinks = function bindRouteLinks() {
    if (!field) return;
    var value = field.value,
      editable = field.editable;
    var hasText = !!value;
    var isEditing = !!editable;
    if (hasText && !isEditing) {
      var node = richTextRef.current;
      if (!node) return;
      // selects all links that start with '/' - this logic may be inappropriate for some advanced uses
      var internalLinks = node.querySelectorAll('a[href^="/"]');
      var newLinks = Array.prototype.filter.call(internalLinks, function (link) {
        return !isFileURL(link);
      });
      newLinks.forEach(function (link) {
        // the component can be updated multiple times during its lifespan,
        // and we don't want to bind the same event handler several times so unbind first
        link.removeEventListener('click', routeHandler, false);
        link.addEventListener('click', routeHandler, false);
      });
    }
  };
  useEffect(function () {
    bindRouteLinks();
  }, [props]);

  // Remove props that come from withRouter, as we don't want to show them in the output HTML.
  var newProps = _objectSpread({}, props);
  delete newProps.match;
  delete newProps.location;
  delete newProps.staticContext;
  delete newProps.history;
  return /*#__PURE__*/React.createElement(RichText, _extends({}, newProps, {
    ref: richTextRef
  }));
};
export default RoutableSitecoreRichText;